import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
      <Link to="/" className="hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
        <i className="ri-home-4-line"></i>
      </Link>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-xs text-foreground-600"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-300">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}